import { backgroundRippleMarkup } from './backgroundRippleMarkup';

export let backgroundRippleMixinBlock  = {
	initBackgroundRipple: (self) => {
		self.$element = self.$element || $(self.element);

		if(self.$element.data('backgroundRipple')) {
			self.$element.css({
				position: 'relative'
			});

			// The child element has a -inner class value.
			let $inner = self.$element.find('[background-ripple-inner]');
			let $innerContent = $inner.find('[background-ripple-inner-content]');

			// Requires the inner divs to have a z-index
			$innerContent.css({
				zIndex: 60,
				position: 'relative'
			});

			let y = !_.isNil(self.$element.data('backgroundRippleY')) ? self.$element.data('backgroundRippleY') : 50;
			if(y < 0 || y > 100) {
				console.error('BackgroundRippleMixinBlock::Error', 'Please supply a valid y position between 0–100%');
				return;
			}

			let x = !_.isNil(self.$element.data('backgroundRippleX')) ? self.$element.data('backgroundRippleX') : 50;
			if(x < 0 || x > 100) {
				console.error('BackgroundRippleMixinBlock::Error', 'Please supply a valid x position between 0–100%');
				return;
			}

			// backgroundRippleMarkup
			let svgObject = svgjs(self.$element[0]).viewbox(0, 0, 743, 959).svg(backgroundRippleMarkup);
			let $svgElement = $(svgObject.node);
			$svgElement.css({
				position: 'absolute',
				top: `${y}%`,
				left: `${x}%`,
				zIndex: 50,
				width: '60%',
				height: 'auto',
				transform: 'translate3d(-50%, -50%, 0)',
				pointerEvents: 'none'
			});
		}
	}
};
